import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// import Searchable from "react-searchable-dropdown";
import { Helmet } from "react-helmet";
import axios from "axios";
import Navbarlogedin from "./Navbarlogedin";
import CompletedInterview from "./cards/CompletedInterview";

import "./Dashboard.css";
const Dashboard = () => {
  const [list, setList] = useState([
    "Data Science",
    "Banking and Finance",
    "Consulting",
  ]);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  let navigate = useNavigate();

  const [profiledata, setProfileData] = useState("");
  useEffect(() => {
    async function fetchData() {
      const req = await axios
        .get(`${process.env.REACT_APP_SERVER_URL}/send/student/112964740830785165733`)
        .then((response) => {
          setProfileData(response.data);
        })
        .catch((error) => {
          console.log("ERROR");
          console.log(error);
        });
    }
    fetchData();
  }, []);
  // Profile Completion Percentage
  const [percent, setPercent] = useState(10);
  // const completion = () => {
  //   var count = 0;
  //   if (user.username) {
  //     count += 1;
  //   }
  //   if (user.thumbNail) {
  //     count += 1;
  //   }
  //   if (user.email) {
  //     count += 1;
  //   }
  //   if (user.mobNumber) {
  //     count += 1;
  //   }
  //   if (user.institute) {
  //     count += 1;
  //   }
  //   if (user.program) {
  //     count += 1;
  //   }
  //   if (user.branch) {
  //     count += 1;
  //   }
  //   if (user.profile) {
  //     count += 1;
  //   }
  //   if (user.dp) {
  //     count += 1;
  //   }
  //   if (user.resume) {
  //     count += 1;
  //   }
  //   if (user.linkedin) {
  //     count += 1;
  //   }
  //   console.log((count / 10) * 100);
  //   return setPercent((count / 10) * 100);
  // };
  // useEffect(() => {
  //   completion();
  // }, []);

  return (
    <>
      <Helmet>
        <title>Interwiu | My Profile</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <div className="interviews w-full">
        <div className="w-full p-2 my-2 border-2 rounded flex justify-center">
          <Typography
            variant="h4"
            component="h4"
            sx={{
              // textAlign: "center",
              display: "inline",
              color: "#1265a8",
              fontWeight: "bold",
              margin: "0 auto",
            }}
          >
            My Profile
          </Typography>
        </div>
        <div className="grid mx-2" id="profile-cont">
          <div className="m-2 overflow-hidden">
            <div className="border rounded mb-2">
              <div className="h-32 opacity-80 overflow-hidden">
                <img src={require("../../images/cover2.webp")} alt="Cover" />
              </div>
              <div className="relative grid py-2" id="profile-bio">
                <div className="relative">
                  <div className="absolute w-40 h-40 -top-16 left-3">
                    <img
                      // src={localStorage.getItem("isAuthenticated").thumbNail}
                      src={require("../../images/photo.png")}
                      className="h-full w-full object-cover rounded-full p-1 border bg-white"
                      alt="Profile"
                    />
                  </div>
                </div>
                <div>
                  <Typography
                    variant="h4"
                    component="h4"
                    sx={{
                      color: "#e84c3d",
                      fontWeight: "bold",
                    }}
                  >
                    {
                      JSON.parse(localStorage.getItem("isAuthenticated"))
                        .username
                    }
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ lineHeight: 1, fontSize: "16px" }}
                  >
                    {profiledata.program ? profiledata.program : ""}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ lineHeight: 1, fontSize: "16px" }}
                  >
                    {profiledata.branch ? profiledata.branch : ""}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ lineHeight: 1, fontSize: "16px" }}
                  >
                    B.Tech, IIT Kharagpur
                    {/* {profiledata.institute ? profiledata.institute : ""} */}
                  </Typography>

                  <p className="text-gray-500 leading-5"></p>
                  <div className="text-2xl my-1 flex w-40 justify-between">
                    <div className="hover:text-blue-500 hover:bg-gray-100 text-blue-500 cursor-pointer border rounded p-2 w-12 text-center">
                      <i
                        className="fa-brands fa-linkedin"
                        onClick={() => {
                          window.open(
                            profiledata.linkedInURL
                              ? profiledata.linkedInURL
                              : "/dashboard",
                            "_blank"
                          );
                        }}
                      ></i>
                    </div>
                    <div className="hover:text-blue-500 hover:bg-gray-100 text-black cursor-pointer border rounded p-2 w-12 text-center">
                      <i
                        className="fa-brands fa-github"
                        onClick={() => {
                          window.open(
                            profiledata.githubURL
                              ? profiledata.githubURL
                              : "/dashboard",
                            "_blank"
                          );
                        }}
                      ></i>
                    </div>
                    <div className="hover:text-blue-500 hover:bg-gray-100 text-blue-500 cursor-pointer border rounded p-2 w-12 text-center">
                      <i
                        className="fa-brands fa-twitter"
                        onClick={() => {
                          window.open(
                            profiledata.twitterURL
                              ? profiledata.twitterURL
                              : "/dashboard",
                            "_blank"
                          );
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="relative">
                  <div className="w-20 border rounded-md mx-auto my-2 px-2 py-1">
                    <img
                      src={require("../../images/iitd.png")}
                      alt="iitd"
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div
                    className="absolute bottom-0 right-18 text-center border rounded-md p-1 mx-auto text-green-600 cursor-pointer hover:text-blue-600 hover:bg-gray-100"
                    onClick={() => {
                      navigate("/profile-form");
                    }}
                  >
                    <p>
                      <i className="fa-solid fa-pen-to-square"></i> Edit Profile
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded border p-2 my-2">
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                }}
              >
                Description
              </Typography>
              <p>I'm a Student, looking for Mock Interview.</p>
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                }}
              >
                Resume
              </Typography>
              <Button variant="contained">
                <i className="fa-solid fa-link"></i> Resume
              </Button>
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                Profile Preference
              </Typography>
              <div>
                <Chip label="Software" variant="outlined" />
                <Chip label="Data Analysis" variant="outlined" />
              </div>
            </div>
            <div className="rounded border p-2 my-2">
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                }}
              >
                Past Mock Interviews
              </Typography>
              <div style={{ margin: "auto 20px" }}>
                <CompletedInterview />
                <CompletedInterview />
              </div>
            </div>
          </div>
          <div className="border rounded p-2 m-2">
            <div className="border rounded mb-2">
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Feeds
              </Typography>
              <Carousel>
                <div>
                  <img src={require("../../images/join-now.jpg")} />
                </div>
                <div>
                  <img src={require("../../images/car-1.jpg")} />
                </div>
                <div>
                  <img src={require("../../images/car-2.jpg")} />
                </div>
                <div>
                  <img src={require("../../images/car-3.jpg")} />
                </div>
              </Carousel>
              {/* <div className="border rounded drop-shadow-lg my-2">
                <img
                  src={require("../../images/join-now.jpg")}
                  alt="Join Now"
                />
              </div> */}
            </div>
            <div className="border rounded p-1 py-2 text-justify">
              <p className="text-sm font-medium">
                Are you looking to appear for a Mock Interview of your choice
                and obtain Personalized Feedback on your performance in
                realtime?
              </p>
              <div className="flex justify-center">
                <Button
                  variant="contained"
                  sx={{ textAlign: "center", fontSize: 12 }}
                  onClick={() => {
                    navigate("/searching");
                  }}
                >
                  Find an Interviewer
                </Button>
              </div>
            </div>
            <div className="border rounded drop-shadow-lg my-2 mx-0">
              <div
                className="mt-4 mx-auto"
                style={{ height: "200px", width: "200px" }}
              >
                <CircularProgressbar value={percent} text={`${percent}%`} />
              </div>
              <div className="text-center pt-2 pb-4">
                <Typography
                  variant="h6"
                  component="h6"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Profile Completion
                </Typography>
                <p>
                  In order to complete your profile, please provide us with the
                  required information.
                </p>
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: 8,
                    backgroundColor: "#00a86b",
                    "&:hover": {
                      backgroundColor: "#00a80b",
                    },
                  }}
                  onClick={() => {
                    navigate("/profile-form");
                  }}
                >
                  Update Your Profile
                </Button>
              </div>
            </div>
            <Typography
              variant="h6"
              component="h6"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Top Interviewers
            </Typography>
            <div>
              <div
                className="border rounded flex justify-between my-2 p-1"
                id="interviewer-card"
              >
                <div className="flex">
                  <div className="mr-1">
                    <img
                      src={require("../../images/photo.png")}
                      alt="Profile"
                      className="w-12 rounded-full"
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-blue-500 leading-5">
                      John Doe
                    </p>
                    <p className="text-gray-500 leading-5">ML Engineer, IBM</p>
                  </div>
                </div>
                <div>
                  <Button
                    variant="outlined"
                    sx={{ width: 80, fontSize: 10, padding: "4px" }}
                  >
                    View Profile
                  </Button>
                </div>
              </div>
              <div
                className="border rounded flex justify-between my-2 p-1"
                id="interviewer-card"
              >
                <div className="flex">
                  <div className="mr-1">
                    <img
                      src={require("../../images/photo.png")}
                      alt="Profile"
                      className="w-12 rounded-full"
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-blue-500 leading-5">
                      John Doe
                    </p>
                    <p className="text-gray-500 leading-5">ML Engineer, IBM</p>
                  </div>
                </div>
                <div>
                  <Button
                    variant="outlined"
                    sx={{ width: 80, fontSize: 10, padding: "4px" }}
                  >
                    View Profile
                  </Button>
                </div>
              </div>
              <div
                className="border rounded flex justify-between my-2 p-1"
                id="interviewer-card"
              >
                <div className="flex">
                  <div className="mr-1">
                    <img
                      src={require("../../images/photo.png")}
                      alt="Profile"
                      className="w-12 rounded-full"
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-blue-500 leading-5">
                      John Doe
                    </p>
                    <p className="text-gray-500 leading-5">ML Engineer, IBM</p>
                  </div>
                </div>
                <div>
                  <Button
                    variant="outlined"
                    sx={{ width: 80, fontSize: 10, padding: "4px" }}
                  >
                    View Profile
                  </Button>
                </div>
              </div>
              <div
                className="border rounded flex justify-between my-2 p-1"
                id="interviewer-card"
              >
                <div className="flex">
                  <div className="mr-1">
                    <img
                      src={require("../../images/photo.png")}
                      alt="Profile"
                      className="w-12 rounded-full"
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-blue-500 leading-5">
                      John Doe
                    </p>
                    <p className="text-gray-500 leading-5">ML Engineer, IBM</p>
                  </div>
                </div>
                <div>
                  <Button
                    variant="outlined"
                    sx={{ width: 80, fontSize: 10, padding: "4px" }}
                  >
                    View Profile
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
